import { COINS, RATION, STAIRS } from "../../tiles";
import Colors from "../Colors";

export const furniture = {
  stairs: {
    displayPriority: 15,
    glyph: {
      fg: Colors.ORANGE_3,
      ch: STAIRS,
    },
    text: {
      name: "Stairs",
      description: "Approach the Stairs and ascend the tower",
    },
    furniture: true,
    collectOnEmpty: false,
    use: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          changeLevel: 1,
        },
      ],
    },
  },
  xpNode: {
    displayPriority: 15,
    glyph: {
      fg: Colors.YELLOW_1,
      ch: COINS,
    },
    text: {
      name: "Coin",
      description: `Gives 1${COINS}`,
    },
    furniture: true,
    collectOnEmpty: true,
    use: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          addXP: 1,
        },
      ],
    },
  },
  refreshSpring: {
    displayPriority: 15,
    glyph: {
      fg: Colors.TEAL_3,
      ch: RATION,
    },
    text: {
      name: "Refresh Sprint",
      description: "Recharges your spells",
    },
    furniture: true,
    collectOnEmpty: false,
    use: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          refreshSpells: 100,
        },
      ],
    },
  },
} as const;
